import React from 'react';
import styles from './switch-button.module.css'; // Import the CSS module

const SwitchButton = ({ isChecked, onChange, label }) => {
    return (
        <div className={styles.switchContainer}>
            {label && <span className={styles.label}>{label}</span>}
            <span className={styles.bool}>OFF</span>
            
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <span className={styles.slider}></span>
            </label>
            <span className={styles.bool}>ON</span>
        </div>
    );
};

export default SwitchButton;